import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface UpdateFirmwareCommand {
  location?: string;
  firmwareId?: string;
  retrieveDate: Date;
  numRetries?: number;
  retryInterval?: number;
  installAt?: Date;
  signingCertificate?: string;
  signature?: string;
}

const client = createClient('/rest/operator-api/charging-stations');

export const updateFirmware: SaveOperation<UpdateFirmwareCommand, void, string> = postRequestFactory<
  UpdateFirmwareCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/firmware-update',
  permissionId: commandPermissions.UPDATE_FIRMWARE
});
